import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { VenueType } from '../../models/VenueType'
import { useAppSelector } from '../../store/hooks'
import { selectVenueTypeById } from '../../store/VenueTypeReducer'

type Props = SBModelComponent<VenueType> & {
  style?: React.CSSProperties
}

export const VenueTypeTag = ({ id, model, style }: Props) => {
  const item = model ? model : useAppSelector(selectVenueTypeById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Tag color={item.color} style={style}>
      {item.name}
    </Tag>
  )
}

export type VenueTypeTagType = { TypeTag: typeof VenueTypeTag }
